import BriefMastheadLogo from './BriefMastheadLogo.jsx';

export default function BriefMasthead({ model, showBottomRule = false }) {
  const issueLine = model.briefDateLong
    ? `${model.briefDateLong} · Morning Brief`
    : 'Morning Brief';

  return (
    <header
      className={[
        'w-full text-center bg-white px-4 sm:px-6 pt-8 sm:pt-10 pb-6 sm:pb-8',
        showBottomRule ? 'border-b border-black' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <h1 className="m-0 p-0 w-full bg-white">
        <BriefMastheadLogo />
      </h1>
      <p className="font-mono text-[13px] sm:text-[14px] tracking-[0.24em] uppercase text-[#C8351A] font-semibold mt-5 sm:mt-6">
        {issueLine}
      </p>
    </header>
  );
}
